module.exports = __webpack_public_path__ + "img/12-1.f0fb3dc8.svg";